<template>
  <div class="h-full mt-36 pb-12 bg-white">
    <h1
      class="text-center py-10 text-gray-800 text-3xl md:text-4xl font-extrabold"
    >
      How Our Platform Works
    </h1>

    <div class="flex justify-center items-center p-4 rounded-xl">
      <div class="w-full max-w-2xl aspect-video rounded-xl">
        <iframe
          class="w-full h-full rounded-xl"
          src="https://drive.google.com/file/d/1Hsx6zJM-dvmVfCnWndEzmtdngd1TaG5S/preview"
          allow="autoplay"
          frameborder="0"
        ></iframe>
      </div>
    </div>

    <ul
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 px-6 md:px-28"
    >
      <li
        class="flex p-6 items-center justify-center flex-col gap-3 text-center"
        v-for="(item, index) in itemHowItsWork"
        :key="index"
      >
        <span>
          <component
            :is="item.image"
            class="h-28 w-28 md:h-36 md:w-36"
          ></component>
        </span>
        <h2 class="text-orange-600 font-semibold text-lg">{{ item.title }}</h2>
        <p class="text-base text-black/80">{{ item.description }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref } from "vue";
import IllustratorCalendar from "@/components/svgs/illustratorCalendar.vue";
import IllustratorVideoCall from "@/components/svgs/illustratorVideoCall.vue";
import IllustratorDocument from "@/components/svgs/illustratorDocument.vue";

export default {
  components: {
    IllustratorCalendar,
    IllustratorVideoCall,
    IllustratorDocument,
  },
  setup() {
    const itemHowItsWork = ref([
      {
        id: 1,
        image: "IllustratorCalendar",
        title: "Take an Online Consultation",
        description:
          "Connect instantly with an available doctor for an online consultation. No appointments needed. Click Consult Now to start and get expert advice immediately.",
      },
      {
        id: 2,
        image: "IllustratorVideoCall",
        title: "Doctor Assessment",
        description:
          "Join a secure video consultation with one of our licensed doctors. Discuss your symptoms and medical concerns from the comfort of your home",
      },
      {
        id: 3,
        image: "IllustratorDocument",
        title: "Easy access to online medical documents",
        description:
          "Get instant access to your e-medical documents right after the consultation. Download them anytime or send directly to your preferred pharmacy.",
      },
    ]);
    return {
      itemHowItsWork,
    };
  },
};
</script>
